import React from 'react';
import {observer} from 'mobx-react';
import {Check} from '@sparkware/app-utils';
import {LauncherComponentWithState} from '../../base-components/launcher-component-with-state';
import TextField from '@material-ui/core/TextField';
import {INPUT_MIN_PADDING, INPUT_MIN_WIDTH} from '../../../launcher-style-consts';
import {IConfigFieldDefinition} from '../../../services/configurations-areas/fields-definitions/config-field-definition-base';


export interface ParseValueResponse {
    value?: any;
    isValid: boolean;
}

export interface TextValueEditorComponentProps {
    fieldDefinition: IConfigFieldDefinition;
    renderInsideDiv?: boolean;
    parseUserInput?: (string) => ParseValueResponse;
    placeholder?: string;
}

export interface TextValueEditorComponentState {
    isError: boolean;
    currentValue: string;
}

@observer
export class TextValueEditorComponent extends LauncherComponentWithState<TextValueEditorComponentProps, TextValueEditorComponentState> {
    static defaultProps = {
        placeholder: 'Default',
        renderInsideDiv: true
    };

    state = {
        isError: false,
        currentValue: ''
    };

    private _setError(currentValue) {
        this.setState({
            isError: true,
            currentValue: currentValue
        });
    }

    private _clearError() {
        if(this.state.isError) {
            this.setState({
                isError: false,
                currentValue: ''
            });
        }
    }


    private _handleChange = (value: any) => {
        if(this.props.parseUserInput) {
            let parseResponse = this.props.parseUserInput(value);
            if(!parseResponse.isValid) {
                this._setError(parseResponse.value);
                return;
            }
            this._clearError();
            value = parseResponse.value;
        }
        this.props.fieldDefinition.setValue(Check.isEmpty(value) ? undefined : value);
    };



    private _getCurrentValue() {
        if(this.state.isError) {
            return this.state.currentValue;
        } else {
            let value = this.props.fieldDefinition.getValue();
            if(Check.isNullOrUndefined(value)) {
                return '';
            } else {
                return value;
            }
        }
    }

    private _renderInput() {
        return (<TextField fullWidth style={{minWidth: INPUT_MIN_WIDTH}} placeholder={this.props.placeholder} label={this.props.fieldDefinition.title} value={this._getCurrentValue()} onChange={(event) => this._handleChange(event.target.value)} />);
    }


    render() {
        if(!this.props.renderInsideDiv) {
            return this._renderInput();
        }
        return (
            <div style={{padding: INPUT_MIN_PADDING}}>
                {this._renderInput()}
            </div>
        );
    }
}